import axios from 'axios';
import { Journey } from '~/@types/Journey';
import { PreJourney } from '~/@types/PreJourney';
import SubscribeJourneyProps from '~/@types/SubscribeJourneyProps';

const apiHttps = axios.create({
  baseURL: `${window.location.origin}/api/v1/frontend/web`,
});

export const initToken = async (token: string): Promise<void> => {
  apiHttps.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
};

export const startCategory = async (source: string): Promise<PreJourney> => {
  const result = await apiHttps
    .post<PreJourney>('categories', { source })
    .then(r => r.data as PreJourney);
  return result;
};

export const start = async (source: string): Promise<Journey> => {
  const result = await apiHttps
    .post<Journey>('journeys', { source })
    .then(r => r.data as Journey);
  return result;
};

export const getMessage = async (code: number): Promise<any> => {
  return apiHttps.get(`messages?code=${code}`).then(r => r.data);
};

export const validateCpf = async (
  journeyId: string,
  cpf: string,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, { cpf })
    .then(r => r.data as Journey);
};

export const validateExecuteSubscribe = async (
  journeyId: string,
  subscribe: SubscribeJourneyProps,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, subscribe)
    .then(r => r.data as Journey);
};

export const enrollSubscribe = async (
  journeyId: string,
  subscribe: SubscribeJourneyProps,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, subscribe)
    .then(r => r.data as Journey);
};

export const sendAnswerQuiz = async (
  journeyId: string,
  answerId: string,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, {
      answerId,
    })
    .then(r => r.data as Journey);
};

export const sendOfferJourney = async (
  journeyId: string,
  offerId: string,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, {
      offerId,
    })
    .then(r => r.data as Journey);
};

export const confirmQuizNegativeJourney = async (
  journeyId: string,
): Promise<Journey> => {
  return apiHttps
    .put<Journey>(`journeys/${journeyId}`, {})
    .then(r => r.data as Journey);
};
